<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment/moment";

export default {
    page: {
        title: "Returning Patient",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: {Layout, PageHeader},

    data() {
        return {
            // PAGE HEADERS
            title: "Returning Patient",
            items: [
                {
                    text: "Clients Section",
                    href: "/",
                },
                {
                    text: "Returning Patient",
                    active: true,
                },
            ],
            departments: [
                { name: 'Consultation', id: '1' },
                { name: 'Radiology', id: '2' },
                { name: 'Procedure', id: '3' },
                { name: 'Laboratory', id: '4' },
                { name: 'Dental', id: '6' },
                { name: 'Other Services', id: '8' },
                { name: 'Antenatal', id: '7' }
            ],
            search:{
                term: 'James',
            },
            found_patients:[],
            isSearching: false,
            isFetching: false,
            isSaving: false,
            company_id_error:'',
            package_id_error:'',
            newVisitData:{
                patient:'',
                company_id:'',
                patient_id:'',
                visit_date:moment(new Date()).format("YYYY-MM-DD"),
                package_id:'',
                patient_dob:'',
                patient_age:'',
                age_unit:'1',
                age_choice:'age',
                next_of_kin:'',
                next_of_kin_phone:'',
                bill_type:'personal',
                department:'',
                service_id:''
            },
            companies: [],
            packages: [],
            services: [],
            general_error:'',
        };
    },
    methods:{
        searchPatient(){
            //alert('Yes! I am searching for the patient');
            this.isSearching = true;
            axios
                .post("search-returning-client", this.search)
                .then(response => {
                    this.isSearching = false;
                    this.found_patients = response.data.data
                })
                .catch(error=>{
                    this.isSearching = false;
                    // eslint-disable-next-line no-console
                    console.log(error)
                })
        },

        getInsuranceCompanies(){
            this.newVisitData.company_id='';
            if (this.newVisitData.bill_type=='insured'){
                this.isFetching = true;
                this.newVisitData.bill_type='insured';
                axios
                    .get("insurance_company")
                    .then(comp => {
                        this.isFetching = false;
                        this.companies = comp.data.data
                    })
                    .catch(error=>{
                        this.isFetching = false;
                        // eslint-disable-next-line no-console
                        console.log(error)
                    })
            }
        },

        getCompanyPackages(){
            this.isFetching = true;
            this.newVisitData.package_id='';
            this.newVisitData.department='';
            this.company_id_error='';
            this.package_id_error='';
            axios
                .get("insurance_packs/"+this.newVisitData.company_id)
                .then(pack => {
                    this.isFetching = false;
                    this.packages = pack.data.data
                })
                .catch(error=>{
                    this.isFetching = false;
                    // eslint-disable-next-line no-console
                    console.log(error)
                })
        },

        getServices(){
            this.isFetching = true;
            this.newVisitData.service_id = '';
            if (this.newVisitData.bill_type=='personal'){
                if (this.newVisitData.department==4){
                    axios
                        .get("labservices")
                        .then(ser => {
                            this.isFetching = false;
                            this.services = ser.data.data
                        })
                        .catch(error=>{
                            this.isFetching = false;
                            // eslint-disable-next-line no-console
                            console.log(error)
                        })
                }else {
                    axios
                        .get("otherservice/"+this.newVisitData.department)
                        .then(ser => {
                            this.isFetching = false;
                            this.services = ser.data.data
                        })
                        .catch(error=>{
                            this.isFetching = false;
                            // eslint-disable-next-line no-console
                            console.log(error)
                        })
                }

            }else {
                if (this.newVisitData.company_id==''){
                    this.company_id_error = "Company field is required first";
                    this.isFetching = false;
                    return;
                }else {
                    this.company_id_error = "";
                }
                if (this.newVisitData.package_id==''){
                    this.package_id_error = "Insurance packege field is required first";
                    this.isFetching = false;
                    return;
                }else {
                    this.package_id_error = "";
                }
                axios
                    .get("package-services/"+this.newVisitData.package_id+"/"+this.newVisitData.department)
                    .then(ser => {
                        this.isFetching = false;
                        this.services = ser.data.data
                    })
                    .catch(error=>{
                        this.isFetching = false;
                        // eslint-disable-next-line no-console
                        console.log(error)
                    })
            }
        },

        showVisitModal(client){
            this.newVisitData.bill_type ='personal';
            this.newVisitData.department ='';
            this.companies=[];
            this.packages=[];
            this.packages=[];
            this.services =[];

            this.newVisitData.patient = client.patient_name;
            this.newVisitData.patient_id = client.id;
            this.newVisitData.patient_dob = client.birth_date;
        },

        saveNewVisit(modal_id){
            this.isSaving = true;
            if (this.newVisitData.age_choice=='age' && this.newVisitData.patient_age==''){
                this.general_error = "Patient Age field is required";
                this.isSaving = false;
                return;
            }else {
                this.general_error = "";
            }
            if (this.newVisitData.department==''){
                this.general_error = "Service Categories field is required";
                this.isSaving = false;
                return;
            }else {
                this.general_error = "";
            }
            if (this.newVisitData.service_id==''){
                this.general_error = "Services field is required";
                this.isSaving = false;
                return;
            }else {
                this.general_error = "";
            }

            axios
                .post("visits", this.newVisitData)
                .then(() => {
                    this.isSaving = false;
                    this.closeModal(modal_id);
                    this.searchPatient();
                })
                .catch(error=>{
                    this.isSaving = false;
                    // eslint-disable-next-line no-console
                    console.log(error)
                })
        },

        resetErrors(){
            this.package_id_error = '';
            this.company_id_error = '';
            this.general_error = '';
            this.newVisitData.department = '';
        },

        resetModal() {
            this.newVisitData.company_id = "";
            this.newVisitData.package_id = "";
            this.newVisitData.age_choice = "age";
            this.newVisitData.age_unit = "1";
            this.newVisitData.next_of_kin = "";
            this.newVisitData.next_of_kin_phone = "";
            this.newVisitData.department = "";
            this.newVisitData.service_id = "";
            this.newVisitData.bill_type = "personal";

            this.package_id_error = '';
            this.company_id_error = '';
            this.general_error = '';
        },

        closeModal(modal_id) {
            this.$nextTick(() => {
                this.$bvModal.hide(modal_id);
            });
        },
    }
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h1>Returning Patients</h1>
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-input v-model="search.term" placeholder="Search by patient name, contact, Code or email"></b-form-input>
                            </div>
                            <div class="col-md-4">
                                <b-button variant="primary" @click="searchPatient">Search Patient <b-spinner v-if="isSearching" small label="Small Spinner"></b-spinner> </b-button>
                            </div>
                            <div class="col-md-4">
                                <b-button v-if="this.found_patients.length">Search found {{ this.found_patients.length }} Patients</b-button>
                            </div>
                        </div>
                        <div class="row">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>S/N</th>
                                    <th>Name</th>
                                    <th>Code</th>
                                    <th>Contact</th>
                                    <th>Visits</th>
                                    <th>Joined Date</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(client, index) in this.found_patients" :key="index">
                                    <td>{{ index+1 }}.</td>
                                    <td>{{ client.patient_name }}</td>
                                    <td>{{ client.patient_code }}</td>
                                    <td>{{ client.patient_contact }}</td>
                                    <td>{{ client.visits.length }}</td>
                                    <td>{{ client.created_at }}</td>
                                    <td>
                                        <b-button @click="showVisitModal(client)" size="sm" v-b-modal.addNewVisit><i class="fa fa-plus"></i> Add Visit</b-button>
                                    </td>
                                </tr>
                                <tr v-if="!found_patients.length">
                                    <td colspan="7">No Patients found</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <b-modal size="lg" id="addNewVisit" ref="modal" @show="resetModal" @hidden="resetModal" hide-footer>
                            <template #modal-title>
                                <span class="text-uppercase">
                                    Add visit to {{ newVisitData.patient }}
                                </span>
                            </template>

                            <div class="row">
                                <div class="mb-2 col-md-6">
                                    <label>Visit Date</label>
                                    <input class="form-control" type="date" v-model="newVisitData.visit_date"/>
                                </div>
                                <div class="mb-3 col-md-6">
                                    <label>Do want to record AGE or Birth Date</label>
                                    <select class="form-control" v-model="newVisitData.age_choice">
                                        <option value="dob">Birth Date</option>
                                        <option value="age">Just age</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-md-6" v-show="newVisitData.age_choice=='dob'">
                                    <label>Birth Date</label>
                                    <input type="date" class="form-control" v-model="newVisitData.patient_dob"/>
                                </div>
                                <div class="mb-3 col-md-6" v-show="newVisitData.age_choice=='age'">
                                    <label class="col-form-label" for="age">Patient Age <span class="text-danger">*</span></label>
                                    <div class="input-group">
                                        <input autocomplete="off" id="age" type="number" v-model="newVisitData.patient_age" class="form-control" placeholder="Enter age"/>
                                        <select class="form-control" v-model="newVisitData.age_unit">
                                            <option value="1">Years</option>
                                            <option value="2">Months</option>
                                            <option value="4">Weeks</option>
                                            <option value="3">Days</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="mb-3 col-md-6">
                                    <label>Bill Type</label>
                                    <select class="form-control" @change="getInsuranceCompanies" v-model="newVisitData.bill_type">
                                        <option value="personal">Personal Bill</option>
                                        <option value="insured">Insurance Bill</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-md-6" v-if="newVisitData.bill_type=='insured'">
                                    <label>Insurance Companies ({{ companies.length }})</label>
                                    <select class="form-control" @change="getCompanyPackages" v-model="newVisitData.company_id">
                                        <option value="">Select Insurance Company</option>
                                        <option v-for="(company, c) in companies" :key="c" :value="company.id">{{ company.companyName }}</option>
                                    </select>
                                    <span v-if="company_id_error" class="text-danger fw-bold">{{ company_id_error }}</span>
                                </div>
                                <div class="mb-3 col-md-6" v-if="newVisitData.bill_type=='insured' && newVisitData.company_id">
                                    <label>Insurance Packages ({{ packages.length }})</label>
                                    <select class="form-control" @change="resetErrors" v-model="newVisitData.package_id">
                                        <option value="">Select Insurance Package</option>
                                        <option v-for="(pack, p) in packages" :key="p" :value="pack.id">{{ pack.packageName }}</option>
                                    </select>
                                    <span v-if="package_id_error" class="text-danger fw-bold">{{ package_id_error }}</span>
                                </div>
                                <div class="mb-3 col-md-6">
                                    <label>Service Categories ({{ departments.length }})</label>
                                    <select class="form-control" @change="getServices" v-model="newVisitData.department">
                                        <option value="">Select Service Category</option>
                                        <option v-for="(department, d) in departments" :key="d" :value="department.id">{{ department.name }}</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-md-6" v-if="newVisitData.department">
                                    <label>Services ({{ services.length }})</label>
                                    <select class="form-control" v-model="newVisitData.service_id">
                                        <option value="">Select Service</option>
                                        <option v-for="(ser, s) in services" :key="s" :value="ser.id">{{ ser.serviceName }} ({{ ser.servicePrice }})</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="isFetching" class="loader-line"></div>

                            <span v-if="general_error" class="text-danger text-center fst-italic fw-bold">{{ general_error }}</span>

                            <div class="modal-footer">
                                <button class="btn btn-secondary"
                                    @click="$bvModal.hide('addNewVisit')" type="button"> Close
                                </button>
                                <button class="btn btn-primary" @click="saveNewVisit('addNewVisit')" type="button">
                                    Save Visit
                                    <b-spinner v-if="isSaving" small role="status"></b-spinner>
                                </button>
                            </div>
                        </b-modal>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
.loader-line {
    width: 200px;
    height: 3px;
    position: relative;
    overflow: hidden;
    background-color: #ddd;
    margin: 20px auto;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
}
.loader-line:before {
    content: "";
    position: absolute;
    left: -50%;
    height: 3px;
    width: 40%;
    background-color: rgb(0, 4, 255);
    -webkit-animation: lineAnim 1s linear infinite;
    -moz-animation: lineAnim 1s linear infinite;
    animation: lineAnim 1s linear infinite;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
}

@keyframes lineAnim {
    0% {
        left: -40%;
    }
    50% {
        left: 20%;
        width: 80%;
    }
    100% {
        left: 100%;
        width: 100%;
    }
}
</style>